'use client';

import { useRouter } from 'next/navigation';
import ErrorCont from '@wconcept/wconcept-ui-renewal/components/molecules/ErrorCont';
import { addAsIsMWebDomain } from '@wconcept/wconcept-common/utils/domainUtil';
import { isNativeAppBoth } from '@wconcept/wconcept-common/utils/userAgentUtil';

const errorMsg = {
  type: '404',
  title: '페이지를 찾을 수 없습니다.',
  detail:
    '찾으시는 페이지가 변경되었거나,<br />일시적으로 사용할 수 없는 상태입니다.',
  linkText: '메인 이동하기',
  logo: true,
};

export default function NotFoundClient() {
  // EVENT HANDLER : 링크클릭
  const router = useRouter();

  const onClickLink = async () => {
    if (isNativeAppBoth(window.navigator.userAgent)) {
      window.location.href = 'wconceptkr://actionBarHome';
    } else {
      router.replace('/rn/women');
    }
  };

  return (
    <ErrorCont
      type={errorMsg.type}
      title={errorMsg.title}
      detail={errorMsg.detail}
      linkText={errorMsg.linkText}
      logo={errorMsg.logo}
      onClick={() => {
        onClickLink();
      }}
    />
  );
}
